import './RootLayout.scss';
import { useEffect, useMemo } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import {
    Header,
    Footer,
    ErrorPage,
    FeedbackButton,
} from 'components';
import { useIntercom } from 'hooks';

export default function RootLayout() {
    const { accountId, disputeId, vendorId, invoiceId, paymentId } = useParams();
    const { pathname } = useLocation();

    useIntercom();

    const title = useMemo(() => {
        switch (pathname) {
            case '/':
                return 'Home';
            case '/deductions':
            case `/accounts/${accountId}/deductions`:
                return 'Deductions';
            case `/accounts/${accountId}/vendors/${vendorId}/deductions/${invoiceId}`:
                return `Deduction ${invoiceId}`;
            case '/disputes':
            case `/accounts/${accountId}/disputes`:
                return 'Disputes';
            case `/disputes/${disputeId}`:
                return `Dispute ${disputeId}`;
            case '/invoices':
            case `/accounts/${accountId}/invoices`:
                return 'Invoices';
            case `/accounts/${accountId}/vendors/${vendorId}/invoices/${invoiceId}`:
                return `Invoice ${invoiceId}`;
            case '/payments':
            case `/accounts/${accountId}/payments`:
                return 'Payments';
            case `/accounts/${accountId}/vendors/${vendorId}/payments/${paymentId}`:
                return `Payment ${paymentId}`;
            case '/search':
            case `/accounts/${accountId}/search`:
                return 'Search';
            case '/createdispute':
                return 'Create a Dispute';
            case '/uploadinvoice':
                return 'Upload an Invoice';           
            case '/user':
                return 'User Preferences';
            default:
                return '';
        }
    }, [pathname, accountId, vendorId, invoiceId, paymentId, disputeId]);

    useEffect(() => {
        document.title = 'PRM' + (title && ` | ${title}`);
    }, [title]);

    return (
        <>
            <div className="page">
                <div className="page-content">
                    <Header />
                    <main>
                        <ErrorBoundary FallbackComponent={ErrorPage}>
                            <Outlet />
                        </ErrorBoundary>
                    </main>
                    <Footer />
                    <FeedbackButton />
                    
                </div>
                <FeedbackButton />
            </div>
        </>
    );
}